import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { 
    BienBanBanGiao, 
    ChiTietBienBanBanGiaoModel, 
    BienBanBanGiaoRequest, 
    TimKiemBienBanBanGiaoRequest 
} from "../models/taisan/BienBanBanGiao";
import { TaiSan } from "../models/taisan/TaiSan";
import intance from "../utils/axios";

export const timKiemDSBienBanBanGiao = async (request: TimKiemBienBanBanGiaoRequest, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.bienBanBanGiao.timKiem, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": request.tuKhoa || "",
            "trangThai": request.trangThai,
            "idDonViGiao": request.idDonViGiao,
            "idDonViNhan": request.idDonViNhan,
            "tuNgay": request.tuNgay,
            "denNgay": request.denNgay
        },
        "orderBy": {
            "columnName": "ngayLap",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layChiTietBienBan = async (id: number) => {
    var rs: ChiTietBienBanBanGiaoModel | null = null;
    await intance.get(ApiPaths.bienBanBanGiao.layChiTiet + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuBienBan = async (request: BienBanBanGiaoRequest) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: 0 };

    await intance.post(ApiPaths.bienBanBanGiao.luuBienBan, request)
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const guiYeuCauBanGiao = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "" };

    await intance.post(ApiPaths.bienBanBanGiao.guiYeuCau, JSON.stringify(id), {
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const xacNhanBanGiao = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "" };

    await intance.post(ApiPaths.bienBanBanGiao.xacNhan, { id })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const tuChoiBanGiao = async (id: number, lyDoTuChoi: string) => {
    var response = { trangThai: responseStatus.loi, thongBao: "" };

    await intance.post(ApiPaths.bienBanBanGiao.tuChoi, { id, lyDoTuChoi })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const huyBienBan = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "" };

    await intance.post(ApiPaths.bienBanBanGiao.huyBienBan, JSON.stringify(id), {
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const thuHoiBienBan = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "" };

    await intance.post(ApiPaths.bienBanBanGiao.thuHoiBienBan, JSON.stringify(id), {
        headers: {
            'Content-Type': 'application/json'
        }
    })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const layDanhSachTaiSanCoTheBanGiao = async (idDonVi: number) => {
    var rs: TaiSan[] = [];
    await intance.get(ApiPaths.bienBanBanGiao.layDSTaiSan + "?idDonVi=" + idDonVi)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layTaiSanChinh = async (idTaiSanChinh: number) => {
    var rs: any = null;
    await intance.get(ApiPaths.bienBanBanGiao.layTaiSanChinh + "?idTaiSanChinh=" + idTaiSanChinh)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDsTaiSanPhu = async (idTaiSanChinh: number) => {
    var rs: any[] = [];
    await intance.get(ApiPaths.bienBanBanGiao.layDsTaiSanPhu + "?idTaiSanChinh=" + idTaiSanChinh)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

